/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { Expeditor, File, MapsData, Order, User } from "../../../services";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import { onDebounce, requestErrorDisplay } from "../../../utils";
import { t } from "i18next";
import OrdersCreateExpeditorView from "../../../components/orders/views/OrdersCreateExpeditorView";
import { useLanguage } from "../../../context/LanguageContext";
import { getCitiesRefreshTargets } from "../utils/cityRefresh";
import { getTransportTypeIcon, POINT_TYPES, WEIGHT_UNITS } from "../../../mock";

const ExpeditorOrdersCreatePage = () => {
  const location = useLocation();
  const params = useParams();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(
    location.pathname !== `/expeditor/orders/draft/${orderId}/edit`,
  );
  const [isChangedTitleInMobile, setChangeTitleForMobile] = useState(false);
  const [isBackBtn, setBackBtn] = useState(0);

  // Default data
  const [orderDraft, setOrderDraft] = useState(null);
  const [countries, setCountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState([]);
  const [partners, setPartners] = useState([]);

  const [errors, setErrors] = useState({});
  // FORM
  // Selected data
  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderPhone, setSenderPhone] = useState();
  const [category, setCategory] = useState();
  const [type, setType] = useState();
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [pallet, setPallet] = useState("");
  const [weightUnit, setWeightUnit] = useState(() => ({ ...WEIGHT_UNITS(t).ton }));
  const [details, setDetails] = useState();
  const [copyCount, setCopyCount] = useState(1);
  const [price, setPrice] = useState(0);
  const [algoPrice, setAlgoPrice] = useState(0);
  const [predictedPrice, setPredictedPrice] = useState({});
  const [isAlgoPrice, setIsAlgoPrice] = useState(false);
  const [netPrice, setNetPrice] = useState();
  const [distance, setDistance] = useState();
  const [temperature, setTemperature] = useState();
  const [loadingType, setLoadingType] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState([]);
  const [isTender, setIsTender] = useState(false);
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");
  const [isOwnFleetExecutor, setIsOwnFleetExecutor] = useState(false);
  const [currency, setCurrency] = useState("KZT");

  const [senderName, setSenderName] = useState("");

  const [citiesRefreshCountryId, setCitiesRefreshCountryId] = useState(null);

  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  // files
  const [files, setFiles] = useState([]);
  const [fileInvoice, setInvoiceFile] = useState(null);

  //map
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  const onResetPrice = () => {
    setAlgoPrice(0);
    setNetPrice(0);
    setDistance(0);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo]);

  useEffect(() => {
    if (
      points.length === 0 &&
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume &&
      routeDistance
    ) {
      orderCalculation();
    } else if (points.length !== 0) {
      setAlgoPrice(0);
    }
  }, [points]);

  useEffect(() => {
    if (cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if (user && user.id) {
        await Order.getCountries(currentLanguage)
          .then((response) => {
            console.log("countries", response.data);
            setCountries(response.data);
          })
          .catch((error) => {
            console.log(error);
            toast.error(error);
          });
      } else {
        console.log("Пользователь не определен");
        setCountries([]);
      }

      await Order.getCategories(currentLanguage)
        .then((response) => {
          setCategories(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTypes()
        .then((response) => {
          console.log("types", response.data);
          const typesWithIcons = response.data.map(type => ({
            ...type,
            icon: getTransportTypeIcon(type.value)
          }));
          setTypes(typesWithIcons);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTemperaturesDisc()
        .then((response) => {
          console.log("Temperatures", response.data);
          setTemperatures(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getLoadingTypesDisc(currentLanguage)
        .then((response) => {
          console.log("Temperatures", response.data);
          setLoadingTypes(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } catch (e) {
      toast.error(t('ordersCreate.errors.dataLoadError'));
    } finally {
      setLoadingGet(location.pathname === `/expeditor/orders/draft/${orderId}/edit`);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, [user?.id, currentLanguage]);

  useEffect(() => {
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed" && partner.companyName)
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log("Список пуст");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (
      orderId &&
      location.pathname === `/expeditor/orders/draft/${orderId}/edit` &&
      types.length &&
      temperatures.length &&
      loadingTypes.length &&
      categories.length &&
      countries.length
    ) {
      getOrderDetailDraft();
    }
  }, [orderId, loadingTypes]);

  useEffect(() => {
    if (citiesRefreshCountryId) {
      const responseEvent = (cities) => {
        const targets = getCitiesRefreshTargets(citiesRefreshCountryId, countryFrom, countryTo);
        if (targets.from) setCitiesFrom(cities);
        if (targets.to) setCitiesTo(cities);
        if (targets.from && orderDraft?.CityIdFrom && !cityFrom) {
          setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
        }
      };

      Order.getCities(currentLanguage, citiesRefreshCountryId)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        })
        .finally(() => {
          setCitiesRefreshCountryId(null);
        });
    }
  }, [citiesRefreshCountryId]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesFrom(cities);
      if (orderDraft?.CityIdFrom && !cityFrom) {
        setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
      }
    };

    if (citiesTo.length && countryFrom?.id && countryTo?.id === countryFrom.id) {
      responseEvent(citiesTo);
    } else if (countryFrom?.id) {
      Order.getCities(currentLanguage, countryFrom.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryFrom]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesTo(cities);
      if (orderDraft?.CityIdTo && !cityTo) {
        setCityTo(cities?.find((c) => c.id === orderDraft?.CityIdTo));
      }
    };
    if (citiesFrom.length && countryTo?.id && countryFrom?.id === countryTo.id) {
      responseEvent(citiesFrom);
    } else if (countryTo?.id) {
      Order.getCities(currentLanguage, countryTo.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryTo]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  const getOrderDetailDraft = async () => {
    try {
      const res = await Order.getDraftOrder(orderId);
      const data = JSON.parse(res.data?.jsonData || "null");
      const discDraftKeys = {
        AddressFrom: {
          setEvent: setAddressFrom,
        },
        AddressTo: {
          setEvent: setAddressTo,
        },
        RecipientEmail: {
          setEvent: setRecipientEmail,
        },
        RecipientName: {
          setEvent: setRecipientName,
        },
        RecipientPhoneNumber: {
          setEvent: setRecipientPhone,
        },
        Details: {
          setEvent: setDetails,
        },
        Distance: {
          setEvent: setDistance,
        },
        IsInsurance: {
          setEvent: setInsurance,
        },
        DeclaredPrice: {
          setEvent: setDeclaredPrice,
        },
        CopyCount: {
          setEvent: setCopyCount,
        },
        Volume: {
          valueType: "string",
          setEvent: setVolume,
        },
        Weight: {
          valueType: "string",
          setEvent: setWeight,
        },
        VehicleType: {
          setEvent: setType,
          findKey: "value",
          items: types,
        },
        LoadingTypeId: {
          setEvent: setLoadingType,
          findKey: "id",
          items: loadingTypes,
        },
        Category: {
          setEvent: setCategory,
          findKey: "value",
          items: categories,
        },
        CountryIdFrom: {
          setEvent: setCountryFrom,
          findKey: "id",
          items: countries,
        },
        CountryIdTo: {
          setEvent: setCountryTo,
          findKey: "id",
          items: countries,
        },
        Temperature: {
          setEvent: setTemperature,
        },
      };
      setOrderDraft(data);

      if (data) {
        for (const draftKey in discDraftKeys) {
          const valueFromServer = data[draftKey];
          if (valueFromServer) {
            const item = discDraftKeys[draftKey];
            if (item.findKey) {
              item.setEvent(item.items.find((c) => c[item.findKey] === valueFromServer));
            } else if (item.valueType === "string") {
              item.setEvent(valueFromServer.toString());
            } else {
              item.setEvent(valueFromServer);
            }
          }
        }
      }
      if (data?.ShippingDate) {
        const dateFormat = moment(data?.ShippingDate).format("YYYY-MM-DD");
        setPickUpDate(new Date(dateFormat + "T00:00:00"));
        const startTime = data?.ShippingHourFrom
          ? data?.ShippingHourFrom > 9
            ? data?.ShippingHourFrom
            : "0" + data?.ShippingHourFrom
          : "09";
        const endTime = data?.ShippingHourTo
          ? data?.ShippingHourTo > 9
            ? data?.ShippingHourTo
            : "0" + data?.ShippingHourTo
          : "18";
        setPickUpStartTime(new Date(dateFormat + `T${startTime}:00:00`));
        setPickUpEndTime(new Date(dateFormat + `T${endTime}:00:00`));
      }
      if (data?.UnloadingDate) {
        const dateFormat = moment(data?.UnloadingDate).format("YYYY-MM-DD");
        setDeliveryDate(new Date(dateFormat + "T00:00:00"));
        const startTime = data?.UnloadingHourFrom
          ? data?.UnloadingHourFrom > 9
            ? data?.UnloadingHourFrom
            : "0" + data?.UnloadingHourFrom
          : "09";
        const endTime = data?.UnloadingHourTo
          ? data?.UnloadingHourTo > 9
            ? data?.UnloadingHourTo
            : "0" + data?.UnloadingHourTo
          : "18";
        setDeliveryStartTime(new Date(dateFormat + `T${startTime}:00:00`));
        setDeliveryEndTime(new Date(dateFormat + `T${endTime}:00:00`));
      }
      if (data?.AddressList) {
        const filteredPoints = data.AddressList.slice(1, -1).map((item, index) => {
          const isLoading = item.Type === "Loading";

          return {
            country: countries.find((c) => c.id === item.CountryId) || "",
            city: "",
            tempCityId: item.CityId || "",
            address: item.Address || "",
            shippingDate: item.ShippingDate ? new Date(item.ShippingDate) : null,
            shippingHourFrom: item.ShippingHourFrom || 0,
            shippingHourTo: item.ShippingHourTo || 0,
            latLng: item.LatLng || "",
            type: POINT_TYPES[item.type] ?? 1,
            step: item.Step ?? index + 1,
            isInterimPoint: item.IsInterimPoint ?? false,
            recipientName: isLoading ? (item.SenderName || "") : (item.RecipientName || ""),
            recipientPhoneNumber: isLoading ? (item.SenderPhoneNumber || "") : (item.RecipientPhoneNumber || ""),
            recipientEmail: isLoading ? (item.SenderEmail || "") : (item.RecipientEmail || ""),
            cities: [],
          };
        });

        setPoints(filteredPoints);
      }

    } catch (e) {
      requestErrorDisplay(e);
      throw e;
    } finally {
      setLoadingGet(false);
    }
  };

  const addressList = [
    {
      userAddressId: addressIdFrom,
      countryId: countryFrom?.id,
      cityId: cityFrom?.id,
      address: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime
        ? Number(moment(pickUpStartTime).format("HH"))
        : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      latLng: coordinatesFrom,
      type: 0,
      step: 1,
      isInterimPoint: false,
      recipientName: senderName,
      recipientPhoneNumber: senderPhone,
      recipientEmail: "",
    },
    ...points.map((point, index) => ({
      userAddressId: point?.addressId,
      countryId: point.country.id,
      cityId: point.city.id,
      address: point.address ? point.address : "",
      shippingDate: point.shippingDate ? moment(point.shippingDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: point.shippingHourFrom
        ? Number(moment(point.shippingHourFrom).format("HH"))
        : null,
      shippingHourTo: point.shippingHourTo
        ? Number(moment(point.shippingHourTo).format("HH"))
        : null,
      latLng: point.latLng,
      type: point.type,
      step: index + 2,
      isInterimPoint: true,
      recipientName: point.recipientName,
      recipientPhoneNumber: point.recipientPhoneNumber,
      recipientEmail: point.recipientEmail,
    })),
    {
      userAddressId: addressIdTo,
      countryId: countryTo?.id,
      cityId: cityTo?.id,
      address: addressTo,
      shippingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: deliveryStartTime
        ? Number(moment(deliveryStartTime).format("HH"))
        : null,
      shippingHourTo: deliveryEndTime
        ? Number(moment(deliveryEndTime).format("HH"))
        : null,
      latLng: coordinatesTo,
      type: 1,
      step: points.length + 2,
      isInterimPoint: false,
      recipientName: recipientName,
      recipientPhoneNumber: recipientPhone,
      recipientEmail: recipientEmail,
    },
  ];

  const formData = () => {
    return {
      userId: user.id,
      price: price,
      algoPrice: algoPrice,
      isAlgoPrice: isAlgoPrice,
      netPrice: price,
      countryIdFrom: countryFrom?.id,
      countryNameFrom: countryFrom?.name,
      cityNameFrom: cityFrom?.name,
      cityFromName: cityFrom?.name,
      cityIdFrom: cityFrom?.id,
      addressFrom: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      recipientName: recipientName,
      recipientEmail: recipientEmail,
      recipientPhoneNumber: recipientPhone,
      countryIdTo: countryTo?.id,
      countryNameTo: countryTo?.name,
      cityIdTo: cityTo?.id,
      cityNameTo: cityTo?.name,
      addressTo: addressTo,
      latLng: coordinatesTo,
      unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
      unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
      details: details || t('ordersCreateDesktop.detailsSection.noDescription'),
      weight: weight ? String(weight).replace(",", ".") : null,
      volume: volume ? String(volume).replace(",", ".") : null,
      pallet: pallet ? String(pallet).replace(",", ".") : null,
      unitMeasurement: weightUnit.code,
      category: category?.value,
      vehicleType: type?.value,
      loadingTypeId: loadingType?.id,
      isInsurance: insurance,
      declaredPrice: declaredPrice,
      insurancePrice: insurancePrice,
      copyCount: copyCount,
      isActualCities: isActualCities,
      expeditorId: partner.companyPartnerId,
      expeditors: partnersForTender.map(partner => partner.companyPartnerId),
      tenderDateEnd: (tenderDateEnd && tenderEndTime)
          ? moment(tenderDateEnd)
              .set({
                hour: moment(tenderEndTime).hour(),
                minute: moment(tenderEndTime).minute(),
                second: 0,
                millisecond: 0
              })
              .utc()
              .format()
          : null,
      addressList: addressList,
      isExistInterimPoint: points.length > 0,
      distance: routeDistance ? routeDistance : 0,
      isCommission: false,
      commission: 0,
      currency: currency,
      temperature: temperature,
      type: 1,
    };
  };

  const createDraftOrder = (withAlert = false) => {
    const orderType = orderId ? "updateDraft" : "createDraft";
    const data = formData();

    Order[orderType](data, orderId)
      .then((res) => res.data)
      .then((response) => {
        let oId = orderId;
        if (!oId) {
          oId = response.id;
          setOrderId(oId);
        }

        if (insurance && fileInvoice?.name) {
          uploadFile(oId, fileInvoice);
        }
        if (files.length) {
          files.forEach((f) => uploadFile(oId, f, 5));
        }
        if (withAlert) {
          toast.success(t("ordersCreate.toast.savedToDrafts"));
        }
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay("[createDraftOrder] - Произошла ошибка");
      });
  };

  const saveDraft = (withOutDebounce = false) => {
    if (withOutDebounce) {
      createDraftOrder(true);
    } else {
      onDebounce(() => createDraftOrder(false), 400);
    }
  };

  const createOrder = () => {
    const data = formData();

    setLoading(true);
    setLoadingCreate(true);
    console.log("[CREATE ORDER DATA]", data);

    const createType = "create";

    Order[createType](data)
      .then((res) => res.data)
      .then((response) => {
        const uploadPromises = [];

        const ids = Array.isArray(response) ? response.map((item) => item.id) : [response.id];

        if (files.length) {
          ids.forEach((id) => {
            files.forEach((f) => {
              uploadPromises.push(uploadFile(id, f, 5));
            });
          });
        }

        toast.success(t('ordersCreate.toast.orderCreated'));

        const insuranceUrl = response?.insurance?.paymentUrl;
        if (insurance && insuranceUrl) {
          window.open(insuranceUrl, '_blank');
        }

        if (uploadPromises.length > 0) {
          Promise.all(uploadPromises)
            .finally(() => {
              setLoading(false);
              setLoadingCreate(false);
              onOrderCreated(ids);
            });
        } else {
          onOrderCreated(ids);
        }
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'common.genericError');
      })
      .finally(() => {
        setLoading(false);
        setLoadingCreate(false);
      })

  };

  const orderCalculation = () => {
    if (points.length !== 0) {
      return;
    }

    const data = {
      countryFrom: `${countryFrom?.name}`,
      countryTo: `${countryTo?.name}`,
      weight: weightUnit.key === "kg" ? String(weight/1000).replace(",", ".") : String(weight).replace(",", "."),
      volume: String(volume).replace(",", "."),
      transportType: type.value,
      cargoCategory: category.name,
      loadingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      distance: routeDistance ?  Math.round(routeDistance) : 0,
    };

    Order.getOrderPrice(data)
      .then((response) => {
        if (response.status == 200) {
          if (pickUpDate) {
            setAlgoPrice(response.data.predicted_price);
            setPredictedPrice({});
          } else {
            setPredictedPrice(response.data.predicted_price);
            setAlgoPrice(0);
          }
        } else {
          console.log(response);
          toast.error("[Calculation] - Произошла ошибка, попробуйте позже");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uploadFile = (orderId, file, type = 0) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData)
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'ordersCreate.errors.uploadFileError');
        return Promise.reject(error);
      });
  };

  const onOrderCreated = (orderId) => {
    navigate('/orders/available');
  };

  const queryInsurance = (nextValue = !insurance) => {
    setInsurance(nextValue);
    if (!nextValue) {
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    }
  };
  const calcInsurance = (val) => {
    setDeclaredPrice(val);
    if (+val) setInsurancePrice(Math.trunc((+val / 100) * 0.3));
    else setInsurancePrice(null);
  };

  if (isLoadingGet) {
    return <Loading inBlock />;
  }

  if (user.type !== "Expeditor") {
    return (
      <div className="alert alert-warning text-center" role="alert">
        <strong>{t('common.warning')}</strong> {t('ordersSearch.errors.pageNotAvailable')}
      </div>
    );
  }

  const getPropsData = () => ({
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    types,
    setType,
    setTemperature,
    type,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    senderName,
    setSenderName,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    weightUnit,
    setWeightUnit,
    pallet, 
    setPallet,
    categories,
    category,
    setCategory,
    temperatures,
    temperature,
    loadingTypes,
    loadingType,
    setLoadingType,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    calcInsurance,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    distance,
    price,
    netPrice,
    algoPrice,
    setAlgoPrice,
    predictedPrice,
    setPredictedPrice,
    insurancePrice,
    createLoading,
    copyCount,
    setCopyCount,
    createOrder,
    orderCalculation,
    onResetPrice,
    saveDraft,
    updatePrice,
    setIsСallСities: setCitiesRefreshCountryId,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    isTender,
    setIsTender,
    tenderDateEnd,
    tenderEndTime,
    setTenderDateEnd,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    setSenderPhone,
    routeDistance,
    setRouteDistance,
    setRouteDuration,
    currency,
    setCurrency,
    isOwnFleetExecutor,
    setIsOwnFleetExecutor
  });

  return (
    <>
      {/* {isDesktop && ( */}
      {isLoading && <Loading/>}
      <OrdersCreateExpeditorView
        {...getPropsData()}
        onPriceChange={setPrice}
        errors={errors}
        setErrors={setErrors}
      />

      {/* )} */}
      {/* {isMobile && (
        <OrdersCreateMobileView
          {...getPropsData()}
          setChangeTitleForMobile={setChangeTitleForMobile}
          isChangedTitleInMobile={isChangedTitleInMobile}
          isBackBtn={isBackBtn}
          onPriceChange={updatePrice}
        />
      )} */}
    </>
  );
};

export default ExpeditorOrdersCreatePage;
